import pcRouter from "@/views/template.vue";

const standalone = [
	{
		path: "/",
		name: "login-pc",
		component: () => import("@/views/login/login"),
		meta: { title: "登录" },
	},
	{
		path: "/register",
		name: "register-pc",
		component: () => import("@/views/login/register"),
		meta: { title: "注册" },
	},
	{
		path: "/forgetPwd",
		name: "forgetPwd-pc",
		component: () => import("@/views/login/forgetPwd"),
		meta: {
			title: "重置密码",
		},
	},
];

// PC 端路由 
const main = {
	path: "/home",
	name: "pc",
	component: pcRouter,
	children: [
		{
			path: "home",
			name: "homePc",
			component: () => import("@/views/home/index"),
			meta: {
				title: "首页",
				icon: 'el-icon-s-home'
			},
		},
		{
			path: "chat",
			name: "chatPc",
			component: () => import("@/views/chat/index"),
			meta: {
				title: "聊天",
				icon: "el-icon-s-comment"
			},
		},
		{
			path: "customer",
			name: "customer",
			component: { render: (h) => h('router-view') },
			meta: { title: "客户", icon: "el-icon-s-custom" }, // 父级标题
			children: [
				{
					path: "customerList",
					name: "customerList",
					component: () => import("@/views/customerList/index"),
					meta: { title: "客户列表" },
				},
				{
					path: "chatSetting",
					name: "chatSetting",
					component: () => import("@/views/chatSetting/index"),
					meta: { title: "会话管理" },
				},
				// {
				// 	path: "tagSetting",
				// 	name: "tagSetting",
				// 	component: () => import("@/views/tagSetting/index"),
				// 	meta: { title: "标签管理" },
				// },
				{
					path: "verbalTrick",
					name: "verbalTrick",
					component: () => import("@/views/verbalTrick/index"),
					meta: { title: "话术库" },
				},
				{
					path: "materialList",
					name: "materialList",
					component: () => import("@/views/materialList/index"),
					meta: { title: "素材库" },
				},
			]
		},
		{
			path: "report",
			name: "reportPc",
			component: { render: (h) => h('router-view') },
			meta: { title: "报告", icon: "el-icon-s-marketing" }, // 父级标题
			children: [
				{
					path: "analyze",
					name: "analyzePc",
					component: () => import("@/views/report/analyze"),
					meta: { title: "客户分析" },
				},
				{
					path: "overview",
					name: "overviewPc",
					component: () => import("@/views/report/overview"),
					meta: { title: "服务概览" },
				},
				{
					path: "often",
					name: "oftenPc",
					component: () => import("@/views/report/often"),
					meta: { title: "在线时常" },
				}
			]
		},
		{
			path: "integrated",
			name: "integratedPc",
			component: () => import("@/views/integrated/index"),
			meta: {
				title: "集成",
				icon: "el-icon-menu"
			},
		},
		{
			path: "subscription",
			name: "subscriptionPc",
			component: () => import("@/views/subscription/index"),
			meta: {
				title: "订阅",
				icon: "el-icon-s-finance"
			},
		},
		{
			path: "setup",
			name: "setupPc",
			component: { render: (h) => h('router-view') },
			meta: { title: "设定", icon: "el-icon-s-tools" },
			children: [
				{
					path: "team",
					name: "teamPc",
					component: () => import("@/views/setup/team"),
					meta: { title: "团队管理" },
				}
			]
		},
		{
			path: "personalCenter", // 访问路径为 /home/detail
			name: "personalCenterPc",
			hidden: true,   
			component: () => import("@/views/personalCenter/index"),
			meta: { title: "个人中心", hidden: true }
		},
	]
}

export default [main, ...standalone];
